export enum IframeRatio {
	SIXTEEN_TO_NINE = "ratio-16x9",
	FOUR_TO_THREE = "ratio-4x3",
	ONE_TO_ONE = "ratio-1x1",
	TWENTY_ONE_TO_NINE = "ratio-21x9"
}
